import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import FlexContainer from 'common/components/atoms/FlexContainer';
import RibbonItem from 'common/components/atoms/RibbonItem';
import { history } from 'common/helpers';
import { isPetasenseAdmin, isPetasenseViewer, isAdmin, isAnalyst, isOrgAdmin, isPartnerAdmin, isFmeaEnabled } from 'common/rbac/util';
import { getAccountMenuItems } from 'home/HomePage/utils';
import {
  tabsOnlyForPetasenseAdmins,
  tabsForPetasenseAndPartnerAdmins,
  tabsOnlyForAnalystsAndAdmins,
  tabsOnlyForAnalysts,
  tabsOnlyForOrgAdminsAndPetasenseAdmins,
  groupsExcludedForPartners
} from 'home/HomePage/constants/routes.constants';

const getRoutes = (user, currentAccount, t, isPartnerSite = false) => {
  const hasOrganisation = !!(
    currentAccount &&
    currentAccount.organisation &&
    currentAccount.organisation.id
  );
  let excludeGroupKeys = [];
  let excludeRouteKeys = [];
  if (!isPetasenseAdmin(user) && !isPartnerAdmin(user)) {
    excludeRouteKeys = excludeRouteKeys.concat(tabsForPetasenseAndPartnerAdmins);
  }
  if (!isPetasenseAdmin(user) && !isPetasenseViewer(user)) {
    excludeRouteKeys = excludeRouteKeys.concat(tabsOnlyForPetasenseAdmins);
    if (!isAdmin(user) && !isAnalyst(user)) {
      excludeRouteKeys = excludeRouteKeys.concat(tabsOnlyForAnalystsAndAdmins);
    }
    if (!isAnalyst(user)) {
      excludeRouteKeys = excludeRouteKeys.concat(tabsOnlyForAnalysts);
    }
  }
  // Organisation pages when account has an organisation and user can view org settings.
  if (
    !hasOrganisation
    || !(isPetasenseAdmin(user) || isOrgAdmin(user) || isPartnerAdmin(user))
  ) {
    excludeRouteKeys = excludeRouteKeys.concat(tabsOnlyForOrgAdminsAndPetasenseAdmins);
  }
  if (isPartnerSite) {
    excludeGroupKeys = excludeGroupKeys.concat(groupsExcludedForPartners);
  }
  // FMEA is an early-access premium feature: hide the FMEA Templates page unless
  // the account has it enabled (Petasense staff always pass via isFmeaEnabled).
  if (!isFmeaEnabled(user, currentAccount)) {
    excludeRouteKeys = excludeRouteKeys.concat('fmea-templates');
  }
  return getAccountMenuItems(t, excludeRouteKeys, excludeGroupKeys);
};

const onClickItem = (item) => {
  if (item.external) window.open(item.path, '_blank');
  else history.push(item.path);
};

const AccountMenuItems = ({ user, currentAccount, partnerName, t }) => (
  <FlexContainer id="account-menu-items" direction="column">
    {getRoutes(user, currentAccount, t, partnerName !== 'Petasense').map(item => (
      item.groupName ? (
        <RibbonItem key={item.key} disabled disabledColor="#999B95">
          {item.groupName}
        </RibbonItem>)
        : (
          <RibbonItem
            key={item.key}
            name={item.key}
            fontSize="14px"
            width="max-content"
            onClick={() => onClickItem(item)}
          >
            {item.displayName}
          </RibbonItem>)
    ))}
  </FlexContainer>
);

const mapStateToProps = state => ({
  user: state.user.user,
  currentAccount: state.currentAccount,
  partnerName: state.companyReducer.partner.name
});

export default connect(mapStateToProps, null)(withTranslation()(AccountMenuItems));
